import {ImageRequestParams} from "../models/image/image-request-params";

export class CameraImageRequestParams extends ImageRequestParams {
  constructor(width: Number, height: Number) {
    super({width, height});

    this._resourceName = `bolao24/Icons/Camera_Icon`;
  }
}
